import React from "react";
import styles from "./style.scss";
import cn from "classnames";

export const SkeletonLoading: React.FunctionComponent = () => {
  return (
    <div className={styles.skeletonWrapper}>
      <div className={styles.button} />
      <div className={styles.button} />
      <div className={styles.pages}>
        <div className={cn(styles.page, styles.active)} />
        <div className={styles.page} />
        <div className={styles.page} />
      </div>
      <div className={styles.button} />
      <div className={styles.text} />
    </div>
  );
};
